import CandidateHeader from "../Navigation/CandidateHeader";
import { Outlet } from "react-router-dom";

const CandidateLayout = () => {
  return (
    <div className="relative min-h-screen">
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 -z-10 bg-[radial-gradient(circle_at_6%_92%,rgba(244,114,182,0.11),transparent_26%)]"
      />
      <div className="relative z-10">
        <CandidateHeader />
        <main>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default CandidateLayout;
